import { companiesCompanyIdEmailSelfServeConfigurationData } from "@dashboardApi/apis/companiesCompanyIdEmailSelfServeConfigurationData";

import type { AllRouteEndpoints } from "../routeTypes";

export const companiesCompanyIdEmailSelfServeProvision =
  "/companies/:company_id/email_self_serve/:app_group_id/provision";

// Invalidate the configuration_data query after a successful provision so the
// scene re-fetches and renders the post-provisioning state.
export const companiesCompanyIdEmailSelfServeProvisionCacheKeys: AllRouteEndpoints[] = [
  companiesCompanyIdEmailSelfServeConfigurationData,
];
